import { module } from 'angular';
import postalAddressComponent from './postal-address.component';
import postalAddressInputDirective from './postal-address-input.directive';
import './postal-address.scss';

export default module('app')
	.component('postalAddress', postalAddressComponent)
	.directive('postalAddressInput', postalAddressInputDirective)
	.name;
